export const dateFormat = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'L',
    monthYearA11yLabel: 'YYYY'
  },
};
